import AxiosClient from "../../../services/axios.services";

class FormEvalCompetenciaServices {
  getFormEvalCompetencias = (params) =>
    AxiosClient.get("api/app/monitor_evaluacion/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getFormEvalCompetencia = (id) =>
    AxiosClient.get(`api/app/monitor_evaluacion/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveFormEvalCompetencia = (data) =>
    AxiosClient.post("api/app/monitor_evaluacion/", data, {
      headers: { "Content-Type": "application/json" },
    });

  sendNotifications = (data) =>
    AxiosClient.post("api/app/validar_envio_evaluacion_colaborador/", data, {
      headers: { "Content-Type": "application/json" },
    });

  sendOverviewNotifications = (data) =>
    AxiosClient.post("api/app/evaluacionEnvioNotificacionAceptacion/", data, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Content-Disposition': 'form-data; name="archivo"; filename="Evaluación.pdf"',
      },
    });

  editFormEvalCompetencia = (id, data) =>
    AxiosClient.put(`api/app/monitor_evaluacion/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteFormEvalCompetencia = (id) =>
    AxiosClient.delete(`api/app/monitor_evaluacion/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new FormEvalCompetenciaServices();
